import { render } from "./MainStart.vue?vue&type=template&id=2b66b9ed&scoped=true"
import script from "./MainStart.vue?vue&type=script&lang=js"
export * from "./MainStart.vue?vue&type=script&lang=js"

import "./MainStart.vue?vue&type=style&index=0&id=2b66b9ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b66b9ed"]])

export default __exports__